import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseApi } from "../base.api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AutoComplete,
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import TextArea from "antd/es/input/TextArea";
const AddTranslation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};
  const languageMapping: any = {
    az: "Azerbaijani",
    en: "English",
    ru: "Russian",
    tr: "Turkish",
    pl: "Polish",
    kz: "Kazakh",
  };
  interface Translation {
    id: number;
    key: string;
    value: string;
    language: string;
  }
  const [translations, setTranslations] = useState([
    { language: "en", value: "" },
    { language: "az", value: "" },
    { language: "ru", value: "" },
    { language: "tr", value: "" },
    { language: "pl", value: "" },
    { language: "kz", value: "" },
  ]);
  const [allTranslations, setAllTranslations] = useState<Translation[]>([]);
  const [keyData, setKeyData] = useState<any[]>([]);
  const [filterData, setFilterData] = useState<any[]>([]);
  const [newKeyValue, setNewKeyValue] = useState("");
  const [loading, setLoading] = useState<boolean>(true);
  
  useEffect(() => {
    fetchTranslation();
  }, []);
  const fetchTranslation = async () => {
    try {
      setLoading(true);
      const response = await new BaseApi().fetchData(
        `common-service/v1/translations/az/admin`
      );
      const data = response?.data.data
      if (Array.isArray(data)) {
            const repsonse = data.map((item: any) => {
              const prefix = item.key.split(".");
              return prefix[0];
            });
            console.log(repsonse);
            const uniquePrefixes = Array.from(new Set(repsonse));
      
            setKeyData(uniquePrefixes);
            setFilterData(uniquePrefixes);
          }
      
      setLoading(false);
    } catch (error: any) {
      alert(error.message);
      setLoading(false);
    }
  };
  const handleTranslationChange = (index: any, event: any) => {
    const newTranslations = [...translations];
    newTranslations[index].value = event.target.value;
    setTranslations(newTranslations);
  };
  const searchData = (value: any) => {
    const filtered = filterData.filter((item: any) =>
      item.toLowerCase().includes(value.toLowerCase())
    );
    setKeyData(filtered);
  };

  const handleChange = (e: any) => {
    setNewKeyValue(e);
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const payload = {
      key: newKeyValue,
      translations,
    };
    try {
      const response = await new BaseApi().postData(
        "/common-service/v1/translations",
        payload
      );

      if (response?.status === 201) {
        console.log("succesfully");
        navigate("/main/translations");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Button>
        <Link to={"/main/translations"}>Back </Link>
      </Button>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Card
          style={{ width: 500, marginBottom: 80, marginTop: 80 }}
          title="Create New Translation"
        >
          <form onSubmit={handleSubmit}>
            <Row gutter={16}>
              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <label htmlFor="key">Key:</label>
                  <AutoComplete
                    value={newKeyValue}
                    popupMatchSelectWidth={false}
                    style={{ width: "100%", marginBottom: "12px" }}
                    options={keyData.map((item: any) => ({
                      label: item,
                      value: item,
                    }))}
                    onChange={handleChange}
                    onSearch={(item: any) => searchData(item)}
                  >
                    <Input.Search
                      size="large"
                      placeholder="Enter tarnslation key..."
                    />
                  </AutoComplete>
                </div>
              </Col>

              {translations.map((translation, index) => (
                <Col span={24} key={index}>
                  <div>
                    <label>
                      {languageMapping[translation.language]} Translation:{" "}
                    </label>
                    <TextArea
                      value={translation.value}
                      onChange={(e) => handleTranslationChange(index, e)}
                      placeholder={`Enter value in ${
                        languageMapping[translation.language]
                      }`}
                    />
                  </div>
                </Col>
              ))}
            </Row>
            <Row justify="center" style={{ marginTop: 16 }}>
              <Col>
                <Button type="primary" onClick={handleSubmit}>
                  Create
                </Button>
              </Col>
            </Row>
          </form>
        </Card>
      </div>
    </>
  );
};

export default AddTranslation;
